import React from "react";
import Home from "./components/Home";
import "./index.css";
import {BrowserRouter as Router , Routes , Route, useLocation} from 'react-router-dom'
import Myworks from "./components/Myworks";
import Navbar from "./components/Navbar";
import About from "./components/About";
import { AnimatePresence } from "framer-motion";
import Login from "./components/Login";
import Top from "./components/Top";


const x = 2;
let y = 4;
function update(arg)
{
  return Math.random() + y * arg
}
y = 2;
y = 3
const result = update(x);
console.log(result)
const App = () => {

  
  
  
  const location = useLocation()
  return (
    <>
    
      <Navbar />
      <Top />

      <AnimatePresence mode="wait">
        <Routes location={location} key={location.key}>
          <Route path="/" element={<Home />} />
          <Route path="/my-works" element={<Myworks />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      </AnimatePresence>
    </>
   
  );
};

export default App;
